import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=dda0848e&lang=pug&"
import script from "./DebugPanel.vue?vue&type=script&lang=js&"
export * from "./DebugPanel.vue?vue&type=script&lang=js&"
import style0 from "./DebugPanel.vue?vue&type=style&index=0&id=dda0848e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports